import { render, staticRenderFns } from "./jetRubik.vue?vue&type=template&id=e5dc8640&"
import script from "./jetRubik.vue?vue&type=script&lang=js&"
export * from "./jetRubik.vue?vue&type=script&lang=js&"
import style0 from "./jetRubik.vue?vue&type=style&index=0&id=e5dc8640&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports